import { render, staticRenderFns } from "./Hotels.vue?vue&type=template&id=172f6ed6&scoped=true&"
import script from "./Hotels.vue?vue&type=script&lang=ts&"
export * from "./Hotels.vue?vue&type=script&lang=ts&"
import style0 from "./Hotels.vue?vue&type=style&index=0&id=172f6ed6&prod&lang=scss&"
import style1 from "./Hotels.vue?vue&type=style&index=1&id=172f6ed6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172f6ed6",
  null
  
)

export default component.exports